export const state = {
  accounts: []
}
